import { Node as ProseMirrorNode, Schema, DOMSerializer, } from "prosemirror-model";
import { EditorState as ProseMirrorEditorState, Plugin, TextSelection, } from "prosemirror-state";
import { EditorView as ProseMirrorEditorView, } from "prosemirror-view";
export { keymap } from "prosemirror-keymap";
export { findChildren } from "prosemirror-utils";
export { EditorView as CodeMirrorEditorView, ViewUpdate, } from "@codemirror/view";
export { EditorSelection } from "@codemirror/state";
export { LanguageSupport, HighlightStyle, StreamLanguage, syntaxHighlighting, } from "@codemirror/language";
export { Plugin, Schema, DOMSerializer, TextSelection, ProseMirrorEditorState, ProseMirrorEditorView, ProseMirrorNode, };
export var SlashCommandGroup;
(function (SlashCommandGroup) {
    SlashCommandGroup["Basics"] = "Basics";
    SlashCommandGroup["Advanced"] = "Advanced";
    SlashCommandGroup["Ai"] = "AI";
})(SlashCommandGroup || (SlashCommandGroup = {}));
